import React from 'react';
import { Label, Icon, Tooltip, Caption, GetColor } from 'venn-ui-kit';
import styled from 'styled-components';
import { isNil } from 'lodash';

interface HeaderProps {
  label: string;
  subLabel?: React.ReactNode;
  info?: string;
  link?: string;
  rightContent?: React.ReactNode;
  disabledTooltip?: string;
}

const MetaHeader = ({ label, info, link, rightContent, disabledTooltip, subLabel }: HeaderProps) => (
  <Container>
    <LabelContainer>
      <Label>
        <Tooltip content={disabledTooltip}>{label}</Tooltip>
        {info && (
          <Tooltip content={info}>
            {!isNil(link) ? (
              <StyledInfoLink target="_blank" rel="noopener noreferrer" href={link}>
                <StyledInfoIcon type="info-circle" prefix="far" />
              </StyledInfoLink>
            ) : (
              <StyledInfoIcon type="info-circle" prefix="far" />
            )}
          </Tooltip>
        )}
      </Label>
      {rightContent}
    </LabelContainer>
    <Caption>{subLabel}</Caption>
  </Container>
);

export const Container = styled.div`
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

const StyledInfoLink = styled.a`
  color: inherit;
`;

const StyledInfoIcon = styled(Icon)`
  margin: 0 5px;
  color: ${GetColor.GreyScale.Grey80};
`;

export default MetaHeader;
